module.exports = tns;